import { NbMenuItem } from "@nebular/theme";
import { OfbizForm, OfbizList } from "@urbannex/ofbiz-forms";
import { ConfigOptions, getColumnFieldTitles, getFields, getTarget, SelectedValue, SelectorType} from "@urbannex/view-containers";
import { FACILITY_FORMS } from "./forms";

export const options:ConfigOptions = {
    name: "Facilities Management System",
    title: "FMS",
    menuAndTitleOptions: {
        path: "facilities",
        headerTitle: "Facilities Management System",
        menuItems: [],
        menuTag: "facilitiesMenu"
    },
    listForm: new OfbizList({
        listFormName: "FindFacility",
        columnFieldTitles: getColumnFieldTitles("FindFacility",FACILITY_FORMS),
        listFormLocation: "component://kwikstore/widget/FacilityForms.xml",
        columnFields:getFields("FindFacility",FACILITY_FORMS),
        findParameters:[],
        emptyListMessage: "No inventory found",
        remoteFormData: {
            formData: {
                formName: "FindFacility",
                formLocation: "component://kwikstore/widget/FacilityForms.xml",
                listType: "grid",
                entityName: "",
                viewIndex: 0,
                viewSize: 20
            },
            //parameters:{"facilityId":"WebStoreWarehouse"}
        }
    }),
    findForm: new OfbizForm,
    addForm: new OfbizForm,
    actions: [],
    settings: [],
    masterDetails:[
        {
            title:"Facility Locations",
            addContainerTitle: "Edit Location",
            listContainerTitle: "Locations for Web Store Warehouse",
            isListDetail:false,
            keyMap: { fieldName: "facilityId" },
            addFormName: "EditFacilityLocation",
            listFormName: "FindFacilityLocations",
            listForm: new OfbizList({
                listFormName: "FindFacilityLocations",
                columnFieldTitles: getColumnFieldTitles("FindFacilityLocations", FACILITY_FORMS),
                listFormLocation: "component://kwikstore/widget/FacilityForms.xml",
                columnFields: getFields("FindFacilityLocations", FACILITY_FORMS),
                findParameters: [],
                emptyListMessage: "No locations found",
                remoteFormData: {
                    formData: {
                        formName: "FindFacilityLocations",
                        formLocation: "component://kwikstore/widget/FacilityForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 20
                    },
                    parameters: {facilityId:""},
                    appContext:"facilities"
                }
            }),
            addForm: new OfbizForm({
                title: "Edit Facility Location",
                titleDescriptionField: "locationSeqId",
                formLocation: "component://kwikstore/widget/FacilityForms.xml",
                fields: getFields("EditFacilityLocation", FACILITY_FORMS),
                formName: "EditFacilityLocation",
                target:getTarget("EditFacilityLocation", FACILITY_FORMS),
                appContext: "facilities",
                local: true,
                layout: "SingleColumn",
                breadCrumbData:{
                    displayPrefix:"Facility Location",
                    addFormText:"Add Facility Location",
                    editFormText:"Edit Facility Location",
                    data:{
                        formData:{
                            formName:"EditFacilityLocation",
                            formLocation:"component://kwikstore/widget/OrderViewForms.xml",
                        },
                        endPoint:getTarget("EditFacilityLocation", FACILITY_FORMS),
                        parameters:{
                            facilityId:"",
                            locationSeqId:""
                        }
                    }
                }
            })

        }
    ],
    relations:[
        {
            title:"Inventory Products",
            addContainerTitle: "",
            listContainerTitle: "Facility Inventory By Product",
            keyMap: {fieldName:"facilityId"},
            addFormName: "",
            listFormName: "ListFacilityInventoryByProduct",
            listForm: new OfbizList({
                listFormName: "ListFacilityInventoryByProduct",
                columnFieldTitles: getColumnFieldTitles("ListFacilityInventoryByProduct",FACILITY_FORMS),
                listFormLocation: "component://kwikstore/widget/FacilityForms.xml",
                columnFields:getFields("ListFacilityInventoryByProduct",FACILITY_FORMS),
                findParameters:[{"facilityId":"WebStoreWarehouse"}],
                emptyListMessage: "No inventory found",
                remoteFormData: {
                    formData: {
                        formName: "ListFacilityInventoryByProduct",
                        formLocation: "component://kwikstore/widget/FacilityForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 20
                    },
                    parameters:{"facilityId":"WebStoreWarehouse"}
                }
            })
        },
        {
            title:"Inventory Items",
            addContainerTitle: "",
            listContainerTitle: "Facility Inventory By Item",
            keyMap: {fieldName:"facilityId"},
            addFormName: "",
            listFormName: "ListFacilityInventoryItems",
            listForm: new OfbizList({
                listFormName: "ListFacilityInventoryItems",
                columnFieldTitles: getColumnFieldTitles("ListFacilityInventoryItems", FACILITY_FORMS),
                listFormLocation: "component://kwikstore/widget/FacilityForms.xml",
                columnFields: getFields("ListFacilityInventoryItems", FACILITY_FORMS),
                findParameters: [],
                emptyListMessage: "No inventory items found",
                remoteFormData: {
                    formData: {
                        formName: "ListFacilityInventoryItems",
                        formLocation: "component://kwikstore/widget/FacilityForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 20
                    },
                    parameters: { facilityId: "" }
                }
            })
        }
    ],
    tasks:[
        {
            title: "Receive Inventory By Purchase Order",
            path:"receive-inventory-order",
            selector: {
                title: "Select Purchase Order",
                type: SelectorType.LOOKUP,
                source: new OfbizForm({
                    viewMode: "default",
                    formLocation: "component://kwikstore/widget/FacilityForms.xml",
                    fields: getFields("OrderLookUp", FACILITY_FORMS),
                    formName: "OrderLookUp",
                    layout:"SingleColumn",
                    formAction:"select"
                })
            },
            updater: {
                title: "Receive Inventory For Order",
                updateActions:[
                    {
                        title: "Receive Inventory For Order",
                        isDefault:true,
                        condition:null,
                        updateForm: new OfbizForm({
                            formLocation: "component://kwikstore/widget/FacilityForms.xml",
                            fields: getFields("ReceiveInventoryByPurchaseOrder", FACILITY_FORMS),
                            formName: "ReceiveInventoryByPurchaseOrder",
                            layout:"SingleColumn",
                        })
                    }
                ]
                
            },
            effect: {
                title: "Result",
                result: new OfbizList({
                    listFormName: "ReceiveInventoryResult",
                    columnFieldTitles: getColumnFieldTitles("ReceiveInventoryResult", FACILITY_FORMS),
                    listFormLocation: "component://kwikstore/widget/FacilityForms.xml",
                    columnFields: getFields("ReceiveInventoryResult", FACILITY_FORMS),
                    findParameters: [],
                    emptyListMessage: "No results found",
                    remoteFormData: {
                        formData: {
                            formName: "ReceiveInventoryResult",
                            formLocation: "component://kwikstore/widget/FacilityForms.xml",
                            listType: "grid",
                            entityName: "",
                            viewIndex: 0,
                            viewSize: 20
                        },
                        parameters: { facilityId: "" }
                    }
                })
            }
        },
        {
            title: "Receive Inventory By Product",
            path: "receive-inventory-product",
            selector: {
                title: "Select Product ID",
                type: SelectorType.LOOKUP,
                source: new OfbizForm({
                    formLocation: "component://kwikstore/widget/FacilityForms.xml",
                    fields: getFields("ProductLookUp", FACILITY_FORMS),
                    formName: "ProductLookUp",
                    layout:"SingleColumn",
                    formAction:"select"
                })
            },
            updater: {
                title: "Receive Inventory For Product",
                updateActions:[
                    {
                        title: "Receive Inventory For Product",
                        isDefault:true,
                        condition:null,
                        updateForm: new OfbizForm({
                            formLocation: "component://kwikstore/widget/FacilityForms.xml",
                            fields: getFields("ReceiveInventoryByPurchaseOrder", FACILITY_FORMS),
                            formName: "ReceiveInventoryByPurchaseOrder",
                            layout:"SingleColumn",
                        })
                    }
                ]
                
            },
            effect: {
                title: "",
                result: new OfbizList
            }
        }
    ]
    /* tasks:[
        {
            title: "Receive Inventory By PO",
            source: TaskSource.FORM,
            selector: new OfbizList,
            updater: new OfbizForm,
            result: new OfbizList
        },
        {
            title: "Receive Inventory By Product",
            source: TaskSource.FORM,
            selector: new OfbizForm,
            updater: new OfbizForm,
            result: new OfbizList
        }
    ] */
}

export const baseMenuItems:NbMenuItem[] = [
    {title:"Facilities",group:true},
    {
        title:"Sales",
        children:[
            {title:"List Orders",icon:"list-outline",link:"/admin/orders/sales"},
            {title:"New Sales Order",icon:"plus-outline"},
        ]
    },
    {
        title:"Purchases",
        children:[
            {title:"List Orders",icon:"list-outline",link:"/admin/orders/purchases"},
            {title:"New Purchase Order",icon:"plus-outline"},
        ]
    }
]